import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import Fondo from "../../../images/modulo13/fondoperiodico.png";
import Imagen1 from "../../../images/modulo13/limpiezario.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad10.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[12];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[11].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[11].path}`,
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[13].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[13].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mb-4">
            <li>
              Imagina que la imagen que observaste en la actividad anterior
              acompaña una noticia en el periódico.{" "}
            </li>
            <li>Ahora, completa la siguiente información.</li>
          </ul>
        </div>
      </div>
      <div
        className="p-4 p-md-5"
        style={{
          backgroundImage: `url(${Fondo})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
      >
        <p>Fecha: ________/________/________</p>
        <h4>Exitosa campaña de limpieza de río</h4>
        <p>
          El día de ayer en un distrito de la capital se llevó a cabo una
          actividad para{" "}
          <input type="text" className="form-control w-200 d-inline" />.
        </p>
        <p>
          Los camiones para transportar los desechos fueron prestados por la{" "}
          <input type="text" className="form-control w-200 d-inline" />.
        </p>
        <p>
          La empresa Macana S.A.C. colaboró con la iniciativa donando{" "}
          <input type="text" className="form-control w-200 d-inline" />.
        </p>
        <p>
          Muchos vecinos participaron de la actividad pues consideran que es muy
          importante cuidar nuestro{" "}
          <input type="text" className="form-control w-200 d-inline" />.
        </p>
        <img
          src={Imagen1}
          alt="Electores"
          className="img-fluid"
          style={{ filter: "grayscale(1)" }}
        />
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea las indicaciones: Imagina que la imagen que observaste en la
            actividad anterior acompaña una noticia en el periódico. Ahora,
            completa la siguiente información con tu compañero o compañera.
            Explique que deben imaginar cómo informaría la prensa sobre un caso
            de limpieza del río. A partir de ello, deben llenar los espacios en
            blanco de la noticia que se presenta a continuación. Déles un tiempo
            para trabajar en parejas o con un familiar. Pida sus respuestas. Si bien esta
            actividad puede tener diferentes respuestas, es importante que, al
            completar el texto, se asegure de que este tenga coherencia. Le
            proponemos un ejemplo:
            <ul>
              <li>
                <i>
                  El día de ayer en un distrito de la capital se llevó a cabo
                  una actividad para limpiar el río Rímac. Los camiones para
                  transportar los desechos fueron prestados por la
                  Municipalidad. La empresa Macana S.A.C. colaboró con la
                  iniciativa donando bolsas de basura y guantes. Muchos vecinos
                  participaron de la actividad pues consideran que es muy
                  importante cuidar nuestro entorno/distrito.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
